module.exports = __webpack_public_path__ + "static/media/content-02-m.c27f5d02.png";